import React from 'react'
// import ProfileModal from '@src/Components/ProfileModal'
import { Link, useLocation } from 'react-router-dom'
import { cn } from '@wove/web-ui'
import { Home, Settings, Upload, Users, Building2, Package, DollarSign } from 'lucide-react'
import { useRequiredRoles } from '@src/hooks/useRequiredRoles'
import { useRequiredPermissions } from '@src/hooks/useRequiredPermissions'
import { Role } from '@wove/common/roles'
import { Permissions } from '@wove/common/permissions'
import useUserStore from '@src/state/user'

interface NavItem {
  title: string
  href: string
  icon: React.ReactNode
}

const NAV_ITEMS: NavItem[] = [
  {
    title: 'Dashboard',
    href: '/',
    icon: <Home className="h-5 w-5" />,
  },
  {
    title: 'Shipments',
    href: '/shipments',
    icon: <Package className="h-5 w-5" />,
  },
  {
    title: 'Shipping Rates',
    href: '/upload',
    icon: <DollarSign className="h-5 w-5" />,
  },
  // {
  //   title: 'Files',
  //   href: '/files',
  //   icon: <FileText className="h-5 w-5" />,
  // },
  // {
  //   title: 'Email Copilot',
  //   href: '/email-copilot',
  //   icon: <Mail className="h-5 w-5" />,
  // },
  // {
  //   title: 'Exports',
  //   href: '/exports',
  //   icon: <DownloadCloud className="h-5 w-5" />,
  // },
  // {
  //   title: 'Analytics',
  //   href: '/analytics',
  //   icon: <BarChart3 className="h-5 w-5" />,
  // },
  {
    title: 'Team',
    href: '/manage-users',
    icon: <Users className="h-5 w-5" />,
  },
  {
    title: 'Organization',
    href: '/organization-settings',
    icon: <Building2 className="h-5 w-5" />,
  },
  {
    title: 'Settings',
    href: '/settings',
    icon: <Settings className="h-5 w-5" />,
  },
]

const SideNavigation = () => {
  const { pathname } = useLocation()
  const { hasRole: isAdmin } = useRequiredRoles([Role.ADMIN])
  const { hasPermission: canManageUsers } = useRequiredPermissions([Permissions.MANAGE_USERS])

  // Filter navigation items based on permissions
  const filteredNavItems = NAV_ITEMS.filter((item) => {
    // Only admins can see organization settings
    if (item.href === '/organization-settings' && !isAdmin) {
      return false
    }
    // Only users with MANAGE_USERS permission can see Team
    if (item.href === '/manage-users' && !canManageUsers) {
      return false
    }
    return true
  })

  return (
    <aside className="hidden w-64 shrink-0 border-r md:block">
      <div className="flex h-full flex-col gap-2 p-4">
        <nav className="grid gap-1 py-2">
          {filteredNavItems.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className={cn(
                'flex items-center gap-3 rounded-lg px-3 py-2 text-muted-foreground transition-all hover:text-foreground',
                (pathname === item.href ||
                  (item.href.includes('organization-settings') &&
                    pathname.startsWith('/organization-settings')) ||
                  (item.href === '/shipments' && pathname.startsWith('/shipments'))) &&
                  'bg-muted font-medium text-foreground',
              )}
            >
              {item.icon}
              {item.title}
            </Link>
          ))}
        </nav>
      </div>
    </aside>
  )
}

export default SideNavigation
